<app-pi-indicador-flujo></app-pi-indicador-flujo>
<div class="container">
  <div class="wrapper">   
    <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>
    <div class="div-seccion">
      <!-- secciones-->
      <div class="div-main-content">
        <router-outlet></router-outlet>
      </div>
      <!-- Seccion nav-stepper -->
      <div class="title-section nav-div">

        <app-pi-stepper></app-pi-stepper>
      </div>
    </div>
  </div>
  <div class="content-footer">
    <app-pi-help-footer></app-pi-help-footer>
  </div>
</div>
<app-modal-host></app-modal-host>